export const CorporateContractType = {
ALPHA: "آلفا",
PRO:"پرو",
NEO:"نئو"
}
